export const MEMBER = 'EG0142';
export const MOBILE_BARCODE = '3J0002';
export const DIGITAL_CERTIFICATE = 'CQ0001';
